"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupTypes = exports.unitBehaviorsConst = void 0;
exports.unitBehaviorsConst = ["SUM", "MAX", "MIN", "AVG", "FIRST", "NONE"];
exports.groupTypes = ["table", "group", "list", "childUnits"];
exports.default = exports.groupTypes;
